import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import StyledEngineProvider from '@material-ui/core/StyledEngineProvider';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { CaptureConsole } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { CookiesProvider } from 'react-cookie';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import { APIProvider } from './contexts/APIContext';
import { ApplicantUtilsProvider } from './contexts/ApplicantUtilsContext';
import { AuthProvider } from './contexts/AuthContext';
import { CountryBasedValuesProvider } from './contexts/CountryBasedValuesContext';
import { DialmakerDesktopCacheProvider } from './contexts/dialmakerDesktop/DialmakerDesktopCacheContext';
import { DialmakerDesktopUtilsProvider } from './contexts/dialmakerDesktop/DialmakerDesktopUtilsContext';
import { IdleHelperProvider } from './contexts/IdleHelperContext';
import { IframeUtilsProvider } from './contexts/IframeUtilsContext';
import { SearchProvider } from './contexts/SearchContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { UtilsProvider } from './contexts/Utils';
import { ValidatorContextProvider } from './contexts/ValidatorContext';
// eslint-disable-next-line import/first

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    new CaptureConsole({ levels: ['error'] }) as any, // Some weird type issue here
  ],
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
});

ReactDOM.render(
  <StrictMode>
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <BrowserRouter>
            <CookiesProvider>
              <DialmakerDesktopUtilsProvider>
                <AuthProvider>
                  <SettingsProvider>
                    <UtilsProvider>
                      <APIProvider>
                        <ValidatorContextProvider>
                          <DialmakerDesktopCacheProvider>
                            <SearchProvider>
                              <IframeUtilsProvider>
                                <CountryBasedValuesProvider>
                                  <ApplicantUtilsProvider>
                                    <IdleHelperProvider>
                                      <App />
                                    </IdleHelperProvider>
                                  </ApplicantUtilsProvider>
                                </CountryBasedValuesProvider>
                              </IframeUtilsProvider>
                            </SearchProvider>
                          </DialmakerDesktopCacheProvider>
                        </ValidatorContextProvider>
                      </APIProvider>
                    </UtilsProvider>
                  </SettingsProvider>
                </AuthProvider>
              </DialmakerDesktopUtilsProvider>
            </CookiesProvider>
          </BrowserRouter>
        </LocalizationProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  </StrictMode>,
  document.getElementById('root'),
);
